import { ROUTES } from '@smarthome/ui';
import { Link } from 'react-router-dom';

/**
 * 404 Not Found page
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="text-8xl font-bold text-gray-300 dark:text-zinc-800">404</div>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900 dark:text-white">Page not found</h1>
      <p className="mt-2 text-gray-500 dark:text-zinc-500">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Link
        to={ROUTES.HOME}
        className="mt-6 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700"
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
